/**
 * Placeholder component for where to buy template
 * @returns {JSX.element} temp where to buy template
 */
export default function WhereToBuy() {
  return <section>Where To Buy Template</section>;
}
